import { Stack, styled, Typography } from '@mui/material';

export const StyledCompaniesHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));

export const StyledHeroHeading = styled(Typography)({
  display: 'flex',
  justifyContent: 'center',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
});

export const CompaniesStyledStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(7),
  marginTop: theme.spacing(6),
  textAlign: 'center',
  marginBottom: theme.spacing(16),
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(15),
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(9),
  },
}));
